// ── ViriLogo — 138 centerlines traced 1:1 from original PNG ─────────────
import { _LOGO_PATHS, _LOGO_W, _LOGO_H } from '../../data/logoData';

export default function ViriLogo({
  size = 120,
  showWordmark = true,
  strokeWidth = 5.5,
  strokeColor = '#3D2010',
}) {
  const displayW = size;
  const displayH = showWordmark
    ? Math.round((size * _LOGO_H) / _LOGO_W) + Math.round(size * 0.16)
    : Math.round((size * _LOGO_H) / _LOGO_W);
  const vbH = showWordmark ? _LOGO_H + 140 : _LOGO_H;
  return (
    <svg
      width={displayW}
      height={displayH}
      viewBox={`0 0 ${_LOGO_W} ${vbH}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        stroke={strokeColor}
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
      >
        {_LOGO_PATHS.map((d, i) => (
          <path key={i} d={d} />
        ))}
      </g>
      {showWordmark && (
        <text
          x={_LOGO_W / 2}
          y={_LOGO_H + 105}
          fontFamily="'Playfair Display', Georgia, serif"
          fontStyle="italic"
          fontWeight="400"
          fontSize="72"
          fill="#3D2010"
          textAnchor="middle"
          letterSpacing="1"
        >
          {'Viri’s Clayworks'}
        </text>
      )}
    </svg>
  );
}
